import React from 'react';
import PropTypes from 'prop-types';
import cn from 'src/taskpane/utility/bem';
import { PrimaryButton } from '@fluentui/react';
import './styles.scss';

const className = cn('button');
const el = (name, mod) => cn(className, name, mod);

const Button = ({ variant = 'primary', customClasses = '', customStyles = {}, type = "submit", text, onClick, disabled }) => {
    return <PrimaryButton
        className={`${el(`common ${variant}`)}${customClasses ? ` ${customClasses}` : ''}${disabled ? ' disabled' : ''}`}
        style={customStyles}
        type={type}
        text={text}
        onClick={onClick}
        disabled={disabled}
    />;
};

Button.propTypes = {
    variant: PropTypes.string,
    customClasses: PropTypes.string,
    customStyles: PropTypes.object,
    type: PropTypes.string,
    text: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
};
export default Button;